export const MENU_ITEMS = {
  pos: {
    name: 'Điểm bán hàng',
    items: [
      { name: 'Bán hàng', link: '/pos', state: { full: true, header: true } },
      { name: 'Phiên', link: '/pos-registers' },
      { name: 'Lịch sử', link: '/pos-orders' },
      { name: 'Bác sĩ', link: '/doctors' },
      { name: 'Chuyên khoa', link: '/specializations', permission: 'viewSpecializationList' },
      { name: 'Hoá đơn điện tử', link: '/einvoices' },
      { name: 'Thiết lập', link: '/pos-settings', permission: 'viewPOSSettingList' },
    ],
  },
  product: {
    name: 'Sản phẩm',
    items: [
      { name: 'Danh sách', link: '/products', permission: 'viewProductList' },
      { name: 'Danh mục', link: '/categories', permission: 'viewCategoryList' },
      { name: 'Nhãn', link: '/tags', permission: 'viewTagList' },
      { name: 'Đơn vị tính', link: '/uoms', permission: 'viewUOMList' },
    ],
  },
  customer: {
    name: 'Khách hàng',
    items: [
      { name: 'Danh sách', link: '/customers' },
      { name: 'Nhóm', link: '/customer-groups', permission: 'viewCustomerGroupList' },
    ],
  },
  purchase: {
    name: 'Nhập hàng',
    items: [
      { name: 'Phiếu nhập', link: '/purchase-orders', permission: 'viewPurchaseOrderList' },
      { name: 'Trả hàng NCC', link: '/supplier-returns', permission: 'viewSupplierReturnList' },
      { name: 'Nhà cung cấp', link: '/vendors', permission: 'viewVendorList' },
    ],
  },
  stock: {
    name: 'Kho hàng',
    items: [
      { name: 'Phiếu nhập kho', link: '/receipts', permission: 'viewPurchaseOrderList' },
      { name: 'Kiểm kê', link: '/inventories', permission: 'viewInventoryList' },
      { name: 'Xuất hỏng', link: '/scraps', permission: 'viewScrapList' },
    ],
  },
  expense: {
    name: 'Sổ quỹ',
    items: [{ name: 'Phiếu chi', link: '/expenses', permission: 'viewExpenseList' }],
  },
  report: {
    name: 'Báo cáo',
    items: [
      { name: 'Báo cáo tồn kho', link: '/report/inventory-valuations', permission: 'viewReportInventoryValuation' },
      { name: 'Sổ sách kế toán HKD', link: '/report/hkd-books' },
      { name: 'Bảng kê, tờ khai', link: '/report/hkd-books/declarations' },
      { name: 'Quy trình GPP', link: '/report/sop' },
    ],
  },
};
